import type { FC, SVGProps } from 'react';
import React from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const IconWildberries: FC<IconProps> = (props) => (
    <svg viewBox="0 0 100 100" aria-hidden="true" {...props}>
        <defs>
            <linearGradient id="wbMarkGrad" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0" stopColor="#5c00f0" />
                <stop offset="1" stopColor="#ff2fc5" />
            </linearGradient>
            <clipPath id="wbMarkClip">
                <rect x="0" y="36" width="100" height="64" />
            </clipPath>
        </defs>
        <rect width="100" height="100" rx="29" fill="url(#wbMarkGrad)" />
        <path
            d="M8.55 30 L21 60.51 L31.5 46 L42 60.51 L54.45 30"
            fill="none"
            stroke="#fff"
            strokeWidth="8.3"
            strokeLinejoin="miter"
            strokeMiterlimit="6"
            clipPath="url(#wbMarkClip)"
        />
        <path d="M60 21h8.3v31h-8.3z" fill="#fff" />
        <circle cx="76.7" cy="52.25" r="12.6" fill="none" stroke="#fff" strokeWidth="8.3" />
    </svg>
);

export const IconSupplierPortal: FC<IconProps> = (props) => (
    <svg viewBox="0 0 100 100" aria-hidden="true" {...props}>
        <rect
            x="13.75"
            y="39.75"
            width="46.5"
            height="46.5"
            fill="none"
            stroke="#b0b0b0"
            strokeWidth="15.5"
        />
        <rect
            x="39.75"
            y="13.75"
            width="46.5"
            height="46.5"
            fill="#fff"
            stroke="#fff"
            strokeWidth="22.5"
        />
        <rect
            x="39.75"
            y="13.75"
            width="46.5"
            height="46.5"
            fill="none"
            stroke="#e1251b"
            strokeWidth="15.5"
        />
    </svg>
);
